import React, { useState, useMemo } from 'react';
import { Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown, faPlus, faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';
import { groupCapabilities } from '../utils/helpers';



// ── Collapsible module > RT > capabilities (assign mode) ─────────────────────
const AssignCapabilitiesTree = ({ capabilities, onAssign, search }) => {
  const [openModules, setOpenModules] = useState({});
  const [openRTs, setOpenRTs] = useState({});

  const filtered = capabilities.filter(c =>
    !search ||
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    (c.targetResourceType || '').toLowerCase().includes(search.toLowerCase())
  );
  const grouped = useMemo(() => groupCapabilities(filtered), [filtered]);
  const moduleKeys = Object.keys(grouped).sort();

  const toggleModule = (mod) => setOpenModules(p => ({ ...p, [mod]: !p[mod] }));
  const toggleRT = (key) => setOpenRTs(p => ({ ...p, [key]: !p[key] }));

  return (
    <div className="module-groups-list">
      {moduleKeys.map(mod => {
        const rts = grouped[mod];
        const modOpen = !!openModules[mod];
        const total = Object.values(rts).flat().length;
        return (
          <div key={mod} className="module-group">
            <div className="module-group-header" onClick={() => toggleModule(mod)}>
              <div className="module-header-left">
                <FontAwesomeIcon icon={faChevronDown} className={`rt-collapse-icon ${modOpen ? '' : 'collapsed'}`} />
                <span className="module-header-name">{mod}</span>
                <Badge className="auth-badge-role module-count-badge">{total}</Badge>
              </div>
            </div>
            {modOpen && (
              <div className="module-group-body">
                {Object.entries(rts).sort(([a],[b]) => a.localeCompare(b)).map(([rt, caps]) => {
                  const rtKey = `${mod}__${rt}`;
                  const rtOpen = !!openRTs[rtKey];
                  return (
                    <div key={rt} className="role-modal-rt-group">
                      <div className="role-modal-rt-header" onClick={() => toggleRT(rtKey)}>
                        <div className="rt-header-left">
                          <FontAwesomeIcon icon={faChevronDown} className={`rt-collapse-icon ${rtOpen ? '' : 'collapsed'}`} />
                          <span className="rt-header-name">{rt}</span>
                          <Badge className="rt-count-badge">{caps.length}</Badge>
                        </div>
                      </div>
                      {rtOpen && (
                        <div className="caps-assign-list">
                          {caps.map(cap => (
                            <div key={cap.id} className="cap-assign-row">
                              <div className="cap-assign-info">
                                <strong className="cap-assign-name">{cap.name}</strong>
                                {cap.description && <span className="cap-assign-desc">{cap.description}</span>}
                                {cap.requiredDimensions?.length > 0 && (
                                  <div className="cap-dims mt-1">
                                    {cap.requiredDimensions.map(d => (
                                      <Badge key={d} className="dim-badge">{d}</Badge>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <Button className="auth-btn-assign" onClick={() => onAssign(cap)}>
                                <FontAwesomeIcon icon={faPlus} className="me-1" />
                                Assign
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
      {moduleKeys.length === 0 && (
        <div className="auth-empty">
          <FontAwesomeIcon icon={faShieldAlt} className="auth-empty-icon" />
          <p>No capabilities found</p>
        </div>
      )}
    </div>
  );
};


export default AssignCapabilitiesTree;